<p-drawer [(visible)]="visible" position="right" [dismissible]="true" [modal]="false"
    styleClass="ai-chat-drawer" (onShow)="open()" (visibleChange)="onVisibleChange($event)">
    <ng-template pTemplate="header">
        <div class="drawer-header">
            <div class="drawer-title">
                <i class="fa-solid fa-robot"></i>
                <span>AI Assistant</span>
            </div>
            <div class="drawer-header-actions">
                <button type="button" class="expand-btn" (click)="openFullChat()" title="Open full AI Chat">
                    <i class="pi pi-external-link"></i>
                </button>
                <button type="button" class="close-btn" (click)="close()" title="Close">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="drawer-chat-container">
            <!-- State context indicator -->
            @if (stateContext.pageTitle) {
            <div class="context-indicator">
                <i class="pi pi-info-circle"></i>
                <span>You're on: <strong>{{ stateContext.pageTitle }}</strong></span>
            </div>
            }

            <!-- Messages -->
            <div class="drawer-messages" #chatMessages>
                @for (msg of messages(); track $index) {
                <div class="message-row" [class.user]="msg.sender.userRole !== 'AI_AGENT'"
                    [class.bot]="msg.sender.userRole === 'AI_AGENT'">
                    <div class="message-bubble">
                        <div class="message-text" [innerHTML]="convertToHtml(msg.textContent, !!msg.sources?.length)"></div>

                        <!-- Source references -->
                        @if (msg.sources && msg.sources.length > 0) {
                        <div class="message-sources">
                            <span class="sources-label">Sources:</span>
                            @for (src of msg.sources; track src.manualId) {
                            <span class="source-tag">{{ src.pageTitle || src.module }}</span>
                            }
                        </div>
                        }

                        <div class="message-time">{{ msg.timestamp | date:'shortTime' }}</div>
                    </div>
                </div>
                }

                @if (isLoading()) {
                <div class="message-row bot">
                    <div class="message-bubble typing">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                    </div>
                </div>
                }
            </div>

            <!-- Quick prompts -->
            <div class="quick-prompts">
                @for (prompt of quickPrompts; track prompt.label) {
                <button type="button" class="quick-prompt-btn" (click)="sendMessage(prompt.text)">
                    {{ prompt.label }}
                </button>
                }
            </div>

            <!-- Input -->
            <div class="drawer-input-row">
                <input type="text" [(ngModel)]="newMessage" placeholder="Ask a question..."
                    (keyup.enter)="sendMessage()" [disabled]="isLoading()" />
                <button type="button" class="send-btn" (click)="sendMessage()" [disabled]="isLoading() || !newMessage().trim()">
                    <i class="pi pi-send"></i>
                </button>
            </div>
        </div>
    </ng-template>
</p-drawer>
